import React, { useState, useEffect, useRef } from 'react';
import { ClipLoader } from 'react-spinners';
import { FaFileDownload, FaCheckCircle, FaTimesCircle, FaChevronDown } from 'react-icons/fa';

function ComissoesTab({
  startDate,
  setStartDate,
  endDate,
  setEndDate,
  comissionStatus,
  setComissionStatus,
  bookingsLoading,
  bookings,
  handleSearch,
  handleQuickFilter,
  groupBookingsByProfessional,
  getProfessionalName,
  handleRowClick,
  handleGeneratePDF,
  setBookings,
  professionals,
  selectedProfessionals,
  setSelectedProfessionals,
  selectedProcedure,
  setSelectedProcedure,
  uniqueProcedures
}) {
  const [reportLoading, setReportLoading] = useState(false);
  const [showIncludePrompt, setShowIncludePrompt] = useState(false);
  const [showProfessionalDropdown, setShowProfessionalDropdown] = useState(false);
  const dropdownRef = useRef(null);

  useEffect(() => {
    if (!startDate || !endDate) return;
    handleSearch();
  }, [startDate, endDate, comissionStatus]);

  useEffect(() => {
    const handleClickOutside = (event) => {
      if (dropdownRef.current && !dropdownRef.current.contains(event.target)) {
        setShowProfessionalDropdown(false);
      }
    };
    document.addEventListener('mousedown', handleClickOutside);
    return () => document.removeEventListener('mousedown', handleClickOutside);
  }, []);

  const handleProfessionalToggle = (profId) => {
    setSelectedProfessionals(prev => 
      prev.includes(profId)
        ? prev.filter(id => id !== profId)
        : [...prev, profId]
    );
  };

  const handleSelectAll = () => {
    if (selectedProfessionals.length === professionals.length) {
      setSelectedProfessionals([]);
    } else {
      setSelectedProfessionals(professionals.map(p => p.id));
    }
  };

  const getSelectedLabel = () => {
    if (selectedProfessionals.length === 0) return 'Todos Profissionais';
    if (selectedProfessionals.length === 1) {
      const prof = professionals.find(p => p.id === selectedProfessionals[0]);
      return prof ? prof.name : 'Profissional';
    }
    return `${selectedProfessionals.length} profissionais`;
  };
  const generateWithChoice = async (include) => {
    if (reportLoading) return;
    try {
      setReportLoading(true);
      setShowIncludePrompt(false);
      await handleGeneratePDF(include === true);
    } finally {
      setReportLoading(false);
    }
  };
  return (
    <div className="caixa-container">
      <div className="caixa-search-filters">
        <div className="date-filters">
          <button 
            className="report-button"
            onClick={() => setShowIncludePrompt(!showIncludePrompt)}
            disabled={reportLoading}
          >
            {reportLoading ? (
              <><ClipLoader size={14} color="#ffffff" /> Gerando...</>
            ) : (
              <><FaFileDownload /> Gerar Relatório</>
            )}
          </button>
          {showIncludePrompt && (
            <div style={{ display: 'flex', alignItems: 'center', gap: '10px', background: '#2a2a2a', padding: '8px 12px', borderRadius: '8px', border: '1px solid #333' }}>
              <span style={{ color: '#e0e0e0' }}>Incluir pagamentos?</span>
              <button
                className="report-button"
                style={{ backgroundColor: '#2e7d32' }}
                onClick={() => generateWithChoice(true)}
                disabled={reportLoading}
              >
                <FaCheckCircle /> Sim
              </button>
              <button
                className="report-button"
                style={{ backgroundColor: '#b91c1c' }}
                onClick={() => generateWithChoice(false)}
                disabled={reportLoading}
              >
                <FaTimesCircle /> Não
              </button>
            </div>
          )}
          <div className="search-professional" ref={dropdownRef} style={{ position: 'relative' }}>
            <button
              type="button"
              className="status-select"
              onClick={() => setShowProfessionalDropdown(!showProfessionalDropdown)}
              style={{ 
                display: 'flex', 
                alignItems: 'center', 
                justifyContent: 'space-between', 
                gap: '8px',
                cursor: 'pointer',
                minWidth: '180px',
                textAlign: 'left'
              }}
            >
              <span>{getSelectedLabel()}</span>
              <FaChevronDown size={12} style={{ 
                transform: showProfessionalDropdown ? 'rotate(180deg)' : 'rotate(0deg)',
                transition: 'transform 0.2s'
              }} />
            </button>
            {showProfessionalDropdown && (
              <div style={{
                position: 'absolute',
                top: '100%',
                left: 0,
                right: 0,
                backgroundColor: '#2a2a2a',
                border: '1px solid #444',
                borderRadius: '6px',
                marginTop: '4px',
                zIndex: 1000,
                maxHeight: '250px',
                overflowY: 'auto',
                boxShadow: '0 4px 12px rgba(0,0,0,0.3)'
              }}>
                <label style={{
                  display: 'flex',
                  alignItems: 'center',
                  gap: '8px',
                  padding: '10px 12px',
                  cursor: 'pointer',
                  borderBottom: '1px solid #444',
                  backgroundColor: '#333',
                  fontWeight: '500'
                }}>
                  <input
                    type="checkbox"
                    checked={selectedProfessionals.length === professionals.length && professionals.length > 0}
                    onChange={handleSelectAll}
                    style={{ width: '16px', height: '16px', accentColor: '#4a90e2' }}
                  />
                  <span style={{ color: '#e0e0e0' }}>
                    {selectedProfessionals.length === professionals.length ? 'Desmarcar Todos' : 'Selecionar Todos'}
                  </span>
                </label>
                {professionals && professionals.length > 0 && professionals.map(prof => (
                  <label key={prof.id} style={{
                    display: 'flex',
                    alignItems: 'center',
                    gap: '8px',
                    padding: '10px 12px',
                    cursor: 'pointer',
                    borderBottom: '1px solid #333',
                    backgroundColor: selectedProfessionals.includes(prof.id) ? '#3a4a5a' : 'transparent',
                    transition: 'background-color 0.15s'
                  }}>
                    <input
                      type="checkbox"
                      checked={selectedProfessionals.includes(prof.id)}
                      onChange={() => handleProfessionalToggle(prof.id)}
                      style={{ width: '16px', height: '16px', accentColor: '#4a90e2' }}
                    />
                    <span style={{ color: '#e0e0e0' }}>{prof.name}</span>
                  </label>
                ))}
              </div>
            )}
          </div>
          <div className="search-professional">
            <select
              value={selectedProcedure}
              onChange={(e) => setSelectedProcedure(e.target.value)}
              className="status-select"
            >
              <option value="">Todos Procedimentos</option>
              {uniqueProcedures && uniqueProcedures.map(proc => (
                <option key={proc} value={proc}>
                  {proc}
                </option>
              ))}
            </select>
          </div>
          <div className="quick-filters">
            <button 
              className="quick-filter-button"
              onClick={() => handleQuickFilter(7)}
            >
              7d
            </button>
            <button 
              className="quick-filter-button"
              onClick={() => handleQuickFilter(15)}
            >
              15d
            </button>
          </div>
          <div className="date-input-group">
            <label>Início:</label>
            <input 
              type="date" 
              value={startDate} 
              onChange={(e) => {
                setStartDate(e.target.value);
                setBookings([]); // Clear current bookings
              }}
              className="date-input"
              required
              onClick={(e) => e.target.showPicker()}
            />
          </div>
          <div className="date-input-group">
            <label>Fim:</label>
            <input 
              type="date" 
              value={endDate} 
              onChange={(e) => {
                setEndDate(e.target.value);
                setBookings([]); // Clear current bookings
              }}
              className="date-input"
              required
              onClick={(e) => e.target.showPicker()}
            />
          </div>
          <div className="date-input-group status-group">
            <label className="status-label-compact">Comissão:</label>
            <select
              value={comissionStatus}
              onChange={(e) => {
                setComissionStatus(e.target.value);
                setBookings([]);
              }}
              className="status-select status-compact"
            >
              <option value="unpaid">Aberta</option>
              <option value="sent">Enviada para pagamento</option>
            </select>
          </div>
        </div>
      </div>

      {bookingsLoading ? (
        <div className="loading-container">
          <ClipLoader size={50} color={"#4a90e2"} />
        </div>
      ) : (
        <div className="bookings-list">
          {Object.entries(groupBookingsByProfessional()).map(([profId, data]) => (
            <div key={profId} className="professional-group">
              <h3>{getProfessionalName(profId)}</h3>
              <table>
                <thead>
                  <tr>
                    <th>Paciente</th>
                    <th>Data</th>
                    <th>Procedimentos</th>
                    <th>Valor</th>
                    <th>Comissão</th>
                    <th>Forma de Pagamento</th>
                    <th>Pagamento</th>
                    <th>Procedimento</th>
                  </tr>
                </thead>
                <tbody>
                  {data.bookings.map((booking, index) => {
                    const isCompleted = booking.status === 'Realizado';
                    const bookingTotal = parseFloat(booking.valorTotal);
                    const bookingDate = booking.dataAtendimento 
                      ? booking.dataAtendimento.split('-').reverse().join('/') 
                      : '-';

                    return (
                      <tr 
                        key={index}
                        onClick={() => handleRowClick(booking)}
                        style={{ 
                          backgroundColor: isCompleted ? '#2e7d32' : 'inherit',
                          color: isCompleted ? '#ffffff' : 'inherit',
                          cursor: 'pointer'
                        }}
                      >
                        <td>{booking.paciente}</td>
                        <td>{bookingDate}</td>
                        <td>
                          {booking.procedimentos?.map((proc, i) => (
                            <div key={i}>{proc.nome}</div>
                          ))}
                        </td>
                        <td>R$ {(parseFloat(bookingTotal) || 0).toFixed(2)}</td>
                        <td>R$ {parseFloat(booking.comission || 0).toFixed(2)}</td>
                        <td>{booking.paymentMethod || '-'}</td>
                        <td>{booking.paymentStatus || 'Pendente'}</td>
                        <td>{booking.status || 'Agendado'}</td>
                      </tr>
                    );
                  })}
                  <tr className="total-row">
                    <td colSpan="3"><strong>Total do Profissional</strong></td>
                    <td><strong>R$ {(data.bookings.reduce((sum, booking) => sum + (parseFloat(booking.valorTotal) || 0), 0)).toFixed(2)}</strong></td>
                    <td><strong>R$ {parseFloat(data.totalComission || 0).toFixed(2)}</strong></td>
                    <td colSpan="3"></td>
                  </tr>
                </tbody>
              </table>
            </div>
          ))}
          {Object.keys(groupBookingsByProfessional()).length > 0 && (
            <div className="grand-total">
              <h3>Total Geral</h3>
              <div className="total-value">
                <div>
                  Valor: R$ {(Object.values(groupBookingsByProfessional())
                    .reduce((total, data) => 
                      total + data.bookings.reduce((sum, booking) => 
                        sum + (parseFloat(booking.valorTotal) || 0), 0), 0))
                    .toFixed(2)}
                </div>
                <div>
                  Comissões: R$ {(Object.values(groupBookingsByProfessional())
                    .reduce((total, data) => total + parseFloat(data.totalComission || 0), 0))
                    .toFixed(2)}
                </div>
              </div>
            </div>
          )}
        </div>
      )}
    </div>
  );
}

export default ComissoesTab; 